// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  index(context, params) {
    const { sortBy, sortDesc, page, itemsPerPage } = params.pagination
      ? params.pagination
      : [null, null, null, null];

    const fields = params.fields ? params.fields : "";
    const expand = params.expand ? params.expand : "";

    const sort = [];
    if(sortBy && sortBy.length){
      for (let idx = 0; idx < sortBy.length; idx++) {
        let s = sortDesc[idx]?'-':'';
        s += sortBy[idx]
        sort.push(s);
      }
    }


    context.commit("set_loading");
    context.commit("clear_products");
    return new Promise(resolve => {
      NewApiService.get("products", {
        page: page,
        sort: sort.join(","),
        rowsPerPage: itemsPerPage,
        search: params.search,
        filter: params.filters,
        fields: fields,
        expand: expand
      })
        .then(({ data }) => {
          context.commit("set_products", data);
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  updatePrice(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put(
        "products/" + params.model.productId + "/price",
        params.model
      )
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  updateSet(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put("products/" + params.productId + "/set", {
        setId: params.setId
      })
        .then(({ data }) => {
          /*context.commit("set_products", data);*/
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  get(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("products/" + params.id, {
        expand: "fields,prices,messages,set,baseProducts,catalogs"
      })
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  getLocations(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("products/" + params.id+'/locations')
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  update(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put("products/" + params.model.id, params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  addToCatalog(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put("products/" + params.id + "/catalog/" + params.catalogId, {})
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  removeToCatalog(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.delete(
        "products/" + params.id + "/catalog/" + params.catalogId,
        {}
      )
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  getProductTypes(context, params = {}) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("products/types", params)
      .then(({ data }) => {
        context.commit("unset_loading");
        resolve(data);
      });
    });
  },

  create(context, params){
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.post("products", params)
      .then(({ data }) => {
        context.commit("unset_loading");
        resolve(data);
      })
      .catch(({response}) => {
        reject(response.data)
      })
    });
  },

  createSet(context, params){
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.post("products/set", params)
      .then(({ data }) => {
        context.commit("unset_loading");
        resolve(data);
      })
      .catch(({response}) => {
        reject(response.data)
      })
    });
  },

  printLabel(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("products/" + params.id + "/print")
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  toggleActivate(context, productId){
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put("products/"+productId+"/toggle")
      .then(({ data }) => {
        context.commit("unset_loading");
        resolve(data);
      })
      .catch(({response}) => {
        reject(response.data)
      })
    })
  },

  canDelete(context, productId){
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.get("products/"+productId+"/can-delete")
      .then(({ data }) => {
        context.commit("unset_loading");
        resolve(data);
      })
      .catch(({response}) => {
        reject(response.data)
      })
    })
  },
  deleteProduct(context, productId){
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.delete("products/"+productId)
      .then(({ data }) => {
        context.commit("unset_loading");
        resolve(data);
      })
      .catch(({response}) => {
        reject(response.data)
      })
    })
  },
  addField(context, params){
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.post("products/"+params.productId+"/fields", params.field)
      .then(({ data }) => {
        context.commit("unset_loading");
        resolve(data);
      })
      .catch(({response}) => {
        reject(response.data)
      })
    })
  }
};
